<div class="border-line"></div>
<div class="buttons"> <button type="button" [disabled]="!validated"  (click)="addRequest();" class="btn btn-primary btn-sm">Add Request</button>  
   <button type="button" (click)="closeParent();" class="btn btn-light btn-sm blue-cir">Cancel</button>
</div>
